module.exports = __webpack_public_path__ + "static/pandora-5281472d968080f78d1a76f76781c032.jpeg";